export const moods = [
  { emoji: '😊', name: 'Happy' },
  { emoji: '😌', name: 'Peaceful' },
  { emoji: '🤔', name: 'Thoughtful' },
  { emoji: '😤', name: 'Frustrated' },
  { emoji: '😔', name: 'Sad' },
  { emoji: '🤗', name: 'Grateful' }
]; 